module.exports = __webpack_public_path__ + "static/media/weather-finder.69b5629a.JPG";